/* BackIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./BackIconButton.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import ChevronLeftIcon from '@atlaskit/icon/utility/chevron-left';
import { Flex } from '@atlaskit/primitives/compiled';
import messages from './messages';
var inPromptHeaderStyles = {
  default: "_1e0c116y _2hwx1b66"
};
var toolTipProps = {
  position: 'top'
};
export var BackIconButton = function BackIconButton(_ref) {
  var inPromptHeader = _ref.inPromptHeader,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    stopPropagation = _ref.stopPropagation,
    onClick = _ref.onClick;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var onClickIconButton = useCallback(function (event) {
    if (stopPropagation) {
      event.stopPropagation();
    }
    onClick === null || onClick === void 0 || onClick();
  }, [stopPropagation, onClick]);
  var btn = /*#__PURE__*/React.createElement(IconButton, {
    isDisabled: isDisabled,
    appearance: "subtle",
    icon: ChevronLeftIcon,
    label: formatMessage(messages.backLabel),
    spacing: "compact",
    isTooltipDisabled: isDisabled,
    onClick: onClickIconButton,
    testId: "back-icon-button",
    tooltip: toolTipProps
  });
  if (inPromptHeader) {
    return /*#__PURE__*/React.createElement(Flex, {
      xcss: inPromptHeaderStyles.default
    }, btn);
  }
  return btn;
};